import { cloneDeep } from "lodash";

export default {
  methods: {
    mapLayerSnowmakingPipeleaksAdd() {
      this.initPollSnowmakingPipeleaks();
      this.map.addSource("snowmaking-pipeleaks-source", {
        type: "geojson",
        data: this.computedSnowmakingPipeleaksGeoJson,
        tolerance: 0
      });

      // 2021 - present
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/orange_2021_to_present.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-2021present", image);
          this.map.addLayer({
            filter: [
              "all",
              [">=", "rep_year", 2021],
              ["==", "rep_comple", "Yes"],
              ["!=", "false_alarm", "Yes"]
            ],
            id: "snowmaking-pipeleaks-2021present",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-2021present",
              "icon-size": 0.05,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-2021present",
            "marker-layer-points"
          );
        }
      );

      // 2017 - 2020
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/yellow_2020_2019_2018_2017.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-2017to2020", image);
          this.map.addLayer({
            filter: [
              "all",
              [">=", "rep_year", 2017],
              ["<=", "rep_year", 2020],
              ["==", "rep_comple", "Yes"],
              ["!=", "false_alarm", "Yes"]
            ],
            id: "snowmaking-pipeleaks-2017to2020",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-2017to2020",
              "icon-size": 0.05,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-2017to2020",
            "marker-layer-points"
          );
        }
      );

      // 2012 - 2016
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/dk_blue_2016_2015_2014_2013_2012.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-2012to2016", image);
          this.map.addLayer({
            filter: [
              "all",
              [">=", "rep_year", 2012],
              ["<=", "rep_year", 2016],
              ["==", "rep_comple", "Yes"],
              ["!=", "false_alarm", "Yes"]
            ],
            id: "snowmaking-pipeleaks-2012to2016",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-2012to2016",
              "icon-size": 0.05,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-2012to2016",
            "marker-layer-points"
          );
        }
      );

      // 2007 - 2011
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/dark_blue_2011_2010_2009_2008_2007.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-2007to2011", image);
          this.map.addLayer({
            filter: [
              "all",
              [">=", "rep_year", 2007],
              ["<=", "rep_year", 2011],
              ["==", "rep_comple", "Yes"],
              ["!=", "false_alarm", "Yes"]
            ],
            id: "snowmaking-pipeleaks-2007to2011",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-2007to2011",
              "icon-size": 0.05,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-2007to2011",
            "marker-layer-points"
          );
        }
      );

      // 2002 - 2006
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/med_blue_2006_2005_2004_2003_2002.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-2002to2006", image);
          this.map.addLayer({
            filter: [
              "all",
              [">=", "rep_year", 2002],
              ["<=", "rep_year", 2006],
              ["==", "rep_comple", "Yes"],
              ["!=", "false_alarm", "Yes"]
            ],
            id: "snowmaking-pipeleaks-2002to2006",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-2002to2006",
              "icon-size": 0.05,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-2002to2006",
            "marker-layer-points"
          );
        }
      );

      // Pre 2002
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/blue_pre_2002.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-2002before", image);
          this.map.addLayer({
            filter: [
              "all",
              ["<=", "rep_year", 2001],
              ["==", "rep_comple", "Yes"],
              ["!=", "false_alarm", "Yes"]
            ],
            id: "snowmaking-pipeleaks-2002before",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-2002before",
              "icon-size": 0.05,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-2002before",
            "marker-layer-points"
          );
        }
      );

      // Not complete
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/not_complete.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-notcomplete", image);
          this.map.addLayer({
            filter: [
              "all",
              ["==", "rep_comple", "No"],
              ["!=", "false_alarm", "Yes"]
            ],
            id: "snowmaking-pipeleaks-notcomplete",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-notcomplete",
              "icon-size": 0.05,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-notcomplete",
            "marker-layer-points"
          );
        }
      );

      // False alarm
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/false_alarm.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-pipeleaks-falsealarm", image);
          this.map.addLayer({
            filter: ["all", ["==", "false_alarm", "Yes"]],
            id: "snowmaking-pipeleaks-falsealarm",
            type: "symbol",
            source: "snowmaking-pipeleaks-source",
            layout: {
              "icon-image": "icon-snowmaking-pipeleaks-falsealarm",
              "icon-size": 0.3,
              "icon-allow-overlap": true,
              "text-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "snowmaking-pipeleaks-falsealarm",
            "marker-layer-points"
          );
        }
      );

      this.map.addLayer({
        filter: [
          "all",
          ["!=", "rep_comple", "No"],
          ["!=", "rep_comple", "Yes"],
          ["!=", "false_alarm", "Yes"]
        ],
        id: "snowmaking-pipeleaks-default",
        type: "circle",
        source: "snowmaking-pipeleaks-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Orange",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });
      this.map.moveLayer("snowmaking-pipeleaks-default", "marker-layer-points");
    },
    mapLayerSnowmakingPipeleaksRemove() {
      this.cancelPollSnowmakingPipeleaks();

      this.map.removeImage("icon-snowmaking-pipeleaks-2021present");
      this.map.removeLayer("snowmaking-pipeleaks-2021present");

      this.map.removeImage("icon-snowmaking-pipeleaks-2017to2020");
      this.map.removeLayer("snowmaking-pipeleaks-2017to2020");

      this.map.removeImage("icon-snowmaking-pipeleaks-2012to2016");
      this.map.removeLayer("snowmaking-pipeleaks-2012to2016");

      this.map.removeImage("icon-snowmaking-pipeleaks-2007to2011");
      this.map.removeLayer("snowmaking-pipeleaks-2007to2011");

      this.map.removeImage("icon-snowmaking-pipeleaks-2002to2006");
      this.map.removeLayer("snowmaking-pipeleaks-2002to2006");

      this.map.removeImage("icon-snowmaking-pipeleaks-2002before");
      this.map.removeLayer("snowmaking-pipeleaks-2002before");

      this.map.removeImage("icon-snowmaking-pipeleaks-notcomplete");
      this.map.removeLayer("snowmaking-pipeleaks-notcomplete");

      this.map.removeImage("icon-snowmaking-pipeleaks-falsealarm");
      this.map.removeLayer("snowmaking-pipeleaks-falsealarm");

      this.map.removeLayer("snowmaking-pipeleaks-default");

      this.map.removeSource("snowmaking-pipeleaks-source");
    },
    initPollSnowmakingPipeleaks() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks",
        dept: "snowmaking",
        layer: "pipeleaks",
        token: this.computedAuthToken
      });
      this.pollSnowmakingPipeleaksInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks",
          dept: "snowmaking",
          layer: "pipeleaks",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollSnowmakingPipeleaks() {
      this.pollSnowmakingPipeleaksInterval = clearInterval(
        this.pollSnowmakingPipeleaksInterval
      );
    }
  },
  computed: {
    // Adds the year of the rep_date so we can use mapbox filters on it.
    computedSnowmakingPipeleaksGeoJson() {
      if (this.$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson) {
        let j = cloneDeep(
          this.$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson
        );
        if (j.features) {
          j.features.map(item => {
            if (item.properties.rep_date !== null) {
              item.properties.rep_year = new Date(
                item.properties.rep_date
              ).getFullYear();
            } else {
              item.properties.rep_year = null;
            }
          });
        }
        return j;
      }
      return [];
    },
    computedSnowmakingPipeleaksMapVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.pipeleaks.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson": {
      handler() {
        if (this.computedSnowmakingPipeleaksGeoJson) {
          this.mapLayerSnowmakingPipeleaksRemove();
          this.mapLayerSnowmakingPipeleaksAdd();
        }
      }
    },
    "$store.state.mapLayers.snowmaking.layers.pipeleaks.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSnowmakingPipeleaksAdd();
      } else {
        this.mapLayerSnowmakingPipeleaksRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollSnowmakingPipeleaks();
  }
};
